import type { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import { twMerge } from "tailwind-merge";

import type { Require } from "@/types/Require";

export function TextButton({
  children,
  className,
  ...props
}: Require<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, "type">) {
  return (
    // oxlint-disable-next-line button-has-type
    <button
      className={twMerge(
        "relative isolate inline text-placeholder not-disabled:cursor-pointer hover:not-disabled:text-black",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
